import $ from 'lib/jquery.ui';

export default window.nvtagDebug ?
  '' :
  $('script[src$="/at.js"], script[src*="/at.js?"]').attr('src').replace(/\/at\.js(.*)$/, '/');
